import { supabase } from '../config/supabase'

const getUserWeddingId = async (userId) => {
  try {
    const { data: profile } = await supabase
      .from('profiles')
      .select('partner_user_id')
      .eq('id', userId)
      .maybeSingle()

    const weddingOwnerId = profile?.partner_user_id || userId

    const { data, error } = await supabase
      .from('weddings')
      .select('id')
      .eq('user_id', weddingOwnerId)
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle()

    if (error && error.code !== 'PGRST116') return null
    return data?.id || null
  } catch (error) {
    console.error('Error getting wedding ID:', error)
    return null
  }
}

/**
 * Obtiene todos los eventos del timeline
 */
export const getTimelineEvents = async (userId) => {
  try {
    const weddingId = await getUserWeddingId(userId)
    if (!weddingId) return []

    const { data, error } = await supabase
      .from('timeline_events')
      .select('*')
      .eq('wedding_id', weddingId)
      .order('event_time', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching timeline events:', error)
    return []
  }
}

/**
 * Crea un evento en el timeline
 */
export const createTimelineEvent = async (userId, eventData) => {
  try {
    const weddingId = await getUserWeddingId(userId)
    if (!weddingId) throw new Error('No wedding found for user')

    const insertData = {
      wedding_id: weddingId,
      event_name: eventData.event_name || '',
      event_time: eventData.event_time || null,
      event_date: eventData.event_date || null,
      location: eventData.location || null,
      notes: eventData.notes || null,
      supplier_id: eventData.supplier_id || null,
      highlighted: eventData.highlighted || false,
    }

    const { data, error } = await supabase
      .from('timeline_events')
      .insert([insertData])
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error creating timeline event:', error)
    throw error
  }
}

/**
 * Actualiza un evento
 */
export const updateTimelineEvent = async (eventId, updates) => {
  try {
    const updateData = {}
    if (updates.event_name !== undefined) updateData.event_name = updates.event_name
    if (updates.event_time !== undefined) updateData.event_time = updates.event_time
    if (updates.event_date !== undefined) updateData.event_date = updates.event_date
    if (updates.location !== undefined) updateData.location = updates.location
    if (updates.notes !== undefined) updateData.notes = updates.notes
    if (updates.supplier_id !== undefined) updateData.supplier_id = updates.supplier_id
    if (updates.highlighted !== undefined) updateData.highlighted = updates.highlighted

    const { data, error } = await supabase
      .from('timeline_events')
      .update(updateData)
      .eq('id', eventId)
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error updating timeline event:', error)
    throw error
  }
}

/**
 * Elimina todos los eventos del timeline (para plantillas)
 */
export const deleteAllTimelineEvents = async (userId) => {
  try {
    const weddingId = await getUserWeddingId(userId)
    if (!weddingId) return

    const { error } = await supabase
      .from('timeline_events')
      .delete()
      .eq('wedding_id', weddingId)

    if (error) throw error
  } catch (error) {
    console.error('Error deleting all timeline events:', error)
    throw error
  }
}

/**
 * Elimina un evento
 */
export const deleteTimelineEvent = async (eventId) => {
  try {
    const { error } = await supabase
      .from('timeline_events')
      .delete()
      .eq('id', eventId)

    if (error) throw error
  } catch (error) {
    console.error('Error deleting timeline event:', error)
    throw error
  }
}
